<template>
  <v-container fluid>
    <v-card flat class="rounded-lg pa-2" height="100%">
      <div class="rounded-lg pageTitle" style="width: 100%;">
        <v-toolbar-title style="font-weight:bold;">{{tables.area_info.title}}</v-toolbar-title>
      </div>
      <div class="rowDiv contentCenter mt-1">
        <div class="pa-1 ml-2 font-weight-black text-h5">{{tables.area_info.subtitle}}</div>
        <div class="pa-0"
          v-for="item in tables.area_info.areaList"
          v-bind:key="item.area_id"
        >
          <v-checkbox 
            dense
            hide-details
            v-model="tables.area_info.area_checked"
            :label="item.area_nm"
            :value="item.area_id"
            @click="tryGetRealTimeAlertPageData"
            v-show="item.area_id.indexOf('DUMMY') !== 0"
            class="mr-5 pt-0 mt-0"
            :disabled="!tables.area_info.isLoadingFinished"
          ></v-checkbox>
        </div>
        <v-spacer>
        </v-spacer>
      </div>
    </v-card>
    <v-card flat class="rounded-lg py-2 mt-2" height="100%">
      <div class="rowDiv contentCenter px-2">
        <div class="rounded-lg pa-1 pageTitle font-weight-black text-h5" style="width: 200px;">警報結案報表</div>
        <div>
          <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="exportFile" :loading="isExporting">匯出</v-btn>
        </div>
        <v-spacer>
        </v-spacer>
        <div class="text-center mr-5">
          <v-pagination
            circle
            v-model="page"
            :length="pageCount"
            total-visible=7
          ></v-pagination>
        </div>
        <v-divider
          class="tableDivider mr-5"
          vertical
          inset
        >
        </v-divider>
        <div class="text-center mr-5 contentCenter">
          共{{total}}筆
        </div>
        <!-- 每頁顯示筆數 -->
        <div style="width:180px">
          <v-select
            :items="rowsList"
            outlined
            class="rounded-lg"
            dense
            v-model="rows"
            hide-details
            prefix="每頁顯示"
            suffix="筆"
          >
          </v-select>
        </div>
      </div>
      <v-data-table
        class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
        hide-default-footer
        :items="eventOverList"
        :headers="headers"
        hide-default-header
        :items-per-page="rows"
        :loading="isLoading"
      >
        <template v-slot:header>
          <thead>
            <tr>
              <th
                class="greyTh"
                v-for="header in headers"
                :key="header.value"
              >
                <div
                  :style="'width:'+header.width+'px'"
                  @click="changeSort(header)"
                  class="sortableThDiv"
                >
                  <div class="sortableThDivText">
                    {{header.text}}
                  </div>
                  <div v-if="header.sortable&&sortItem===header.value">
                    <v-icon v-if="sortOrder">mdi-chevron-down</v-icon>
                    <v-icon v-else>mdi-chevron-up</v-icon>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td 
              v-for="header in headers"
              :key="header.value"
              class="tableTD"
            >
              <div>
                {{item[header.value]}}
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          no data available
        </template>
      </v-data-table>
       <!-- 搜尋 sidebar -->
      <v-navigation-drawer
        app
        clipped
        class="rounded-lg mt-3"
        :width="sidebarWidth"
        height="850"
        permanent
      >
        <div class="rowDiv">
          <v-card-title v-if="sidebarOpen" class="headline font-weight-bold">篩選條件</v-card-title>
          <v-spacer>
          </v-spacer>
          <v-icon
            size = "30"
            style="cursor: pointer;"
            class="mr-5"
            v-if='sidebarOpen'
            @click="sidebarOpen=!sidebarOpen"
          >
            mdi-arrow-expand-left
          </v-icon>
          <v-icon
            size = "30"
            style="cursor: pointer;"
            class="mr-5 mt-5"
            v-else
            @click="sidebarOpen=!sidebarOpen"
          >
            mdi-tune-variant
          </v-icon>
        </div>
        <v-divider></v-divider>
        <div v-if="sidebarOpen">
          <v-card-title style="height:50px;" class="searchTitle">標的物編號</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-text-field
              v-model="searchSiteId"
              class="rounded-lg"
              dense
              outlined
              hide-details
              clearable
            ></v-text-field>
          </div>
          <v-card-title style="height:50px;" class="searchTitle">主機編號</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-text-field
              v-model="searchSiteMno"
              class="rounded-lg"
              dense
              outlined
              hide-details
              clearable
            ></v-text-field>
          </div>
          <v-card-title style="height:50px;" class="searchTitle">主帳號</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-autocomplete
              v-model="searchCustomerId"
              :items="customerInfoList"
              item-text="text"
              item-value="value"
              required
              class="rounded-lg"
              dense
              outlined
              hide-details
              clearable
            >
            </v-autocomplete>
          </div>
          <v-card-title style="height:50px;" class="searchTitle">合約編號</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-text-field
              v-model="searchContractId"
              class="rounded-lg"
              dense
              outlined
              hide-details
              clearable
            ></v-text-field>
          </div>
          <v-card-title style="height:50px;" class="searchTitle">設備區域名稱</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-text-field
              v-model="searchSiteNm"
              class="rounded-lg"
              dense
              outlined
              hide-details
              clearable
            ></v-text-field>
          </div>
          <v-card-title style="height:50px;" class="searchTitle">警報狀態</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-text-field
              v-model="searchStatusNm"
              class="rounded-lg"
              dense
              outlined
              hide-details
              clearable
            ></v-text-field>
          </div>
          <v-card-title style="height:50px;" class="searchTitle">發報時間(起)</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-menu
              ref="searchStartDateMenu"
              v-model="searchStartDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="searchStartDate"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  class="rounded-lg"
                  dense
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="searchStartDate"
                @input="searchStartDateMenu = false"
                no-title
                scrollable
              >
              </v-date-picker>
            </v-menu>
          </div>
          <v-card-title style="height:50px;" class="searchTitle">發報時間(迄)</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-menu
              ref="searchEndDateMenu"
              v-model="searchEndDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="searchEndDate"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  class="rounded-lg"
                  dense
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="searchEndDate"
                @input="searchEndDateMenu = false"
                no-title
                scrollable
              >
              </v-date-picker>
            </v-menu>
          </div>
        </div>
      </v-navigation-drawer>
    </v-card>
  </v-container>
</template>
<script>
// import axios from 'axios'
// import router from '../router'
import Service from '../service/service'
export default {
  name: 'Event_over_list',
  data: () => ({
    isLoading: false,
    isExporting: false,
    tables:{
      area_info: {
        urlGet: 'area_info/getPageData',
        title: '警報結案報表',
        subtitle: '管制區：',
        areaList: [],
        area_checked_timer: null,
        area_checked: [{area_id:'', area_nm:''}],

        isLoadingFinished: true
      },
    },
    headers: [
      { text: '標的物編號', value: 'site_id', width:"110", sortable: false },
      { text: '主機編號', value: 'SiteMNO',width:"110", sortable: false },
      { text: '標的物名稱', value: 'site_nm',width:"120", sortable: false },
      { text: '標的物位置', value: 'site_location',width:"120", sortable: false },
      { text: '設備名稱', value: 'device_nm', width:"110", sortable: false },
      { text: '設備位置', value: 'device_location', width:"110", sortable: false },
      { text: '警報狀態', value: 'status_nm', width:"110", sortable: false },
      { text: '處理作業說明', value: 'Remark',width:"130", sortable: false },
      { text: '發報時間', value: 'EventTime',width:"100", sortable: false },
      { text: '誤報', value: 'ErrorEvent', sortable: false },
      { text: '處理時間', value: 'ProcessAt', width:"110", sortable: false },
      { text: '處理人員', value: 'ProcessUser',width:"110", sortable: false },
    ],
    rows: 10,
    sortItem: 'SeqNo',
    sortOrder: false,
    total: 0,
    pageCount: 0,
    page: 1,
    rowsList: [10, 20, 30, 40, 50],
    controlPermission: [],
    eventOverList: [],
    sidebarOpen: true,
    sidebarWidth: 260,
    searchSiteId: '',
    searchSiteMno: '',
    searchCustomerId: '',
    searchContractId: '',
    searchSiteNm: '',
    searchStatusNm: '',
    searchStartDate: undefined,
    searchEndDate: undefined,
    searchStartDateMenu: false,
    searchEndDateMenu: false,
    rules: {
      content: [v => !!v || 'Required']
    },
    customerInfoList: []
  }),
  mounted: function () {
    // this.path = this.$router.currentRoute.path
    // const control = this.permissions.find(x => x.path === this.path)
    // this.controlPermission = control ? control.permission : []
    this.getAreaInfo(() => {
      this.getDictionary()
      this.setDefultDate()
      this.getPageData()
    })
  },
  watch: {
    sidebarOpen () {
      if (this.sidebarOpen) {
        this.sidebarWidth = 260
      } else {
        this.sidebarWidth = 70
      }
    },    
    'page': {
      handler: function (nvalue, ovalue) {
        if (ovalue === undefined) return
        if (nvalue !== ovalue) { this.getPageData() }
      }
    },
    
    'rows': {
      handler: function (nvalue, ovalue) {
        if (ovalue === undefined) return
        if (nvalue !== ovalue) { this.getPageData() }
      }
    },
    searchSiteId () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchSiteMno () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchCustomerId () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchContractId () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchSiteNm () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchStatusNm () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    'searchStartDate': {
      handler: function (nvalue, ovalue) {
        if (ovalue === undefined) return
        if (nvalue !== ovalue) { this.getPageData() }
      }
    },
    'searchEndDate': {
      handler: function (nvalue, ovalue) {
        if (ovalue === undefined) return
        if (nvalue !== ovalue) { this.getPageData() }
      }
    },
  },
  props: {
    user: null,
    permissions: null,
    isMobile: null
  },
  computed: {
    order () {
      if (this.sortOrder) {
        return 'desc'
      } else {
        return 'asc'
      }
    }
  },
  methods: {
    getAreaInfo(callback) {
      this.tables.area_info.areaList = []
      var wheres = []
      var parm = {
        page: this.page,
        rows: this.rows,
        order: this.order,
        sort: this.sortItem,
        wheres: JSON.stringify(wheres),
        url: this.tables.area_info.urlGet
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            this.tables.area_info.areaList = response.data.rows
            // 版面調整
            if(this.tables.area_info.areaList.length < 8) {
              for(var idx = this.tables.area_info.areaList.length; idx < 8; idx+=1) {
                //this.areaList.push({area_id:'DUMMY'+idx, area_nm: ''})
              }
            }

            this.tables.area_info.area_checked = []
            this.tables.area_info.areaList.forEach(area => {
              if(area.area_id != 999){
                this.tables.area_info.area_checked.push(area.area_id)
              }
            })
            
            if (callback) callback()
          }
        })
    },
    // 簡易輸入防抖機制
    tryGetRealTimeAlertPageData () {
      if (this.tables.area_info.area_checked_timer) {
        clearTimeout(this.tables.area_info.area_checked_timer)
      }
      this.tables.area_info.area_checked_timer = setTimeout(() => {
        // get data
        this.getPageData() 
      }, 500)
    },
    showAlert (type, message) {
      var alert = {
        alertType: null,
        alertMessage: '',
        alertIcon: null
      }
      if (type === 'success') {
        alert.alertType = 'success'
        alert.alertIcon = 'mdi-check-circle'
      } else {
        alert.alertType = 'error'
        alert.alertIcon = 'mdi-alert-circle'
      }
      alert.alertMessage = message
      this.$emit('setAlert', alert)
    },
    changeSort (header) {
      if (!header.sortable) return

      if (header.value === this.sortItem) {
        this.sortOrder = !this.sortOrder
      } else {
        this.sortOrder = true
        this.sortItem = header.value
      }
      this.getPageData()
    },
    getDictionary () {
      var parm = ['customer_info']
      Service.getDictionary(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200) {
            this.showAlert('error', response.data.message)
          } else {
            var customerIndex = response.data.map(function (item) { return item.dicNo }).indexOf('customer_info')
            var customerInfoList = response.data[customerIndex].data
            customerInfoList.forEach(element => {
              var customer = {
                value: element.key,
                text: element.key + ' ' + element.value
              }
              this.customerInfoList.push(customer)
            })
          }
        })
    },
    setDefultDate () {
      let d = new Date()
      let endDate = d.getFullYear()
      if ((d.getMonth() + 1) < 10) {
        endDate = endDate + '-0' + (d.getMonth() + 1)
      } else {
        endDate = endDate + '-' + (d.getMonth() + 1)
      }
      if ((d.getDate()) < 10) {
        endDate = endDate + '-0' + (d.getDate())
      } else {
        endDate = endDate + '-' + (d.getDate())
      }
      this.searchStartDate = this.searchEndDate = endDate
    },
    getPageData() {
      this.isLoading = true
      this.eventOverList = []
      var searchSiteId = {
        name: 'site_id',
        value: this.searchSiteId,
        displayType: 'like'
      }
      var searchSiteMno = {
        name: 'SiteMNO',
        value: this.searchSiteMno,
        displayType: 'like'
      }
      var searchCustomerId = {
        name: 'customer_id',
        value: this.searchCustomerId,
        displayType: '='
      }
      var searchContractId = {
        name: 'site_contract_id',
        value: this.searchContractId,
        displayType: 'like'
      }
      var searchSiteNm = {
        name: 'site_nm',
        value: this.site_nm,
        displayType: 'like'
      }
      var searchStatusNm = {
        name: 'status_nm',
        value: this.searchStatusNm,
        displayType: 'like'
      }
      var searchStartDate = {
        name: 'EventTime',
        value: this.searchStartDate,
        displayType: 'thanorequal'
      }
      var searchEndDate = {
        name: 'EventTime',
        value: this.searchEndDate,
        displayType: 'lessorequal'
      }
      
      var searchAreaId = {
        name: 'area_id_filter',
        value: this.tables.area_info.area_checked.join(','),
        displayType: 'IN'
      }
      var wheres = [searchSiteId, searchSiteMno, searchCustomerId, searchContractId, searchSiteNm, searchStatusNm, searchStartDate, searchEndDate, searchAreaId]
      var parm = {
        page: this.page,
        rows: this.rows,
        order: this.order,
        sort: this.sortItem,
        wheres: JSON.stringify(wheres),
        url: 'event_over_list/getPageData'
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            this.total = response.data.total
            this.pageCount = Math.ceil(this.total / this.rows)
            this.eventOverList = response.data.rows
          }
        })
      .finally(() => {
        this.isLoading = false
      })
    },
    exportFile () {
      this.isExporting = true
      var searchSiteId = {
        name: 'site_id',
        value: this.searchSiteId,
        displayType: 'like'
      }
      var searchSiteMno = {
        name: 'SiteMNO',
        value: this.searchSiteMno,
        displayType: 'like'
      }
      var searchCustomerId = {
        name: 'customer_id',
        value: this.searchCustomerId,
        displayType: '='
      }
      var searchContractId = {
        name: 'site_contract_id',
        value: this.searchContractId,
        displayType: 'like'
      }
      var searchSiteNm = {
        name: 'site_nm',
        value: this.site_nm,
        displayType: 'like'
      }
      var searchStatusNm = {
        name: 'status_nm',
        value: this.site_nm,
        displayType: 'like'
      }
      var searchStartDate = {
        name: 'EventTime',
        value: this.searchStartDate,
        displayType: 'thanorequal'
      }
      var searchEndDate = {
        name: 'EventTime',
        value: this.searchEndDate,
        displayType: 'lessorequal'
      }
      var searchAreaId = {
        name: 'area_id_filter',
        value: this.tables.area_info.area_checked.join(','),
        displayType: 'IN'
      }
      var wheres = [searchSiteId, searchSiteMno, searchCustomerId, searchContractId, searchSiteNm, searchStatusNm, searchStartDate, searchEndDate, searchAreaId]
      var parm = {
        wheres: JSON.stringify(wheres),
        url: 'event_over_list/Export'
      }
      Service.exportFile(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200) {
            this.showAlert('error', response.data.message)
          } else {
            var filename = '警報結案報表.xlsx'
            var downloadURL = ''
            var binaryData = []
            binaryData.push(response.data)
            downloadURL = URL.createObjectURL(new Blob(binaryData, { type: 'application/octet-stream' }))
            var link = document.createElement('a')
            link.href = downloadURL
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            link = null
          }
        })
      .finally(() => {
        this.isExporting = false
      })
    },
  }
}
</script>
